import {i18n} from 'mc/lib';
import PropTypes from 'prop-types';
import React from 'react';
import {NavigationButton} from '../common';

const ZadostBackButton = ({children, ...otherProps}) => (
    <NavigationButton color="default" className="pull-left" {...otherProps}>
        {children || i18n('global.previousStep')}
    </NavigationButton>
);

ZadostBackButton.propTypes = {
    children: PropTypes.node,
};

export default ZadostBackButton;
